import type { SearchParams } from "@/modules/jobAds/client/api/types"
import type { AvailableFilters } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"

export const getJobAdsAvailableFiltersFromSearchParams = (searchParams: SearchParams): AvailableFilters => ({
  abroad_only: searchParams.abroadOnly,
  candidacy_type: searchParams.candidacyTypes,
  company_business_type: searchParams.companyBusinessTypes,
  company_sectors: searchParams.companySectors,
  contract: searchParams.contracts,
  contract_duration: searchParams.contractDurations,
  exclusive: searchParams.exclusive,
  job_with_impact: searchParams.jobWithImpact,
  lat: searchParams.lat,
  lng: searchParams.lng,
  locale: searchParams.locales,
  location: searchParams.locations,
  position_category_uuid: searchParams.positionCategories,
  // eslint-disable-next-line id-length
  q: searchParams.keywords,
  radius: searchParams.radius,
  remote_types: searchParams.remoteTypes,
  start_date: searchParams.startDates,
  study_levels: searchParams.studyLevels,
  tags: searchParams.tags,
  work_experience_code: searchParams.workExperienceCodes,
})
